import {
  CreateDelivery,
  Delivery,
  DeliveryPage,
  GetDeliveriesReportQuery,
  SearchGetManyDeliveriesQueryParams as SearchGetManyDeliveriesQueryParameters,
  UpdateDelivery,
} from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithEdit } from "./mixins/WithEdit";
import { WithSearchableGetPage } from "./mixins/WithSearchableGetPage";

export class Endpoint extends BaseEndpoint("deliveries") {
  async getReport(query: GetDeliveriesReportQuery): Promise<Blob> {
    return this.request("deliveries-report-csv", { query, type: "blob" });
  }
}

const withGetPage = WithSearchableGetPage<
  typeof Endpoint,
  Delivery,
  DeliveryPage,
  SearchGetManyDeliveriesQueryParameters
>(Endpoint);

export const DeliveryEndpoint = WithEdit<typeof withGetPage, Delivery, CreateDelivery, UpdateDelivery>(withGetPage);
